import React from "react";
import { Checkbox } from "antd";
import { PlayCircleFilled } from "@ant-design/icons";
import MediaFetcher from "../library/MediaFetcher";
import { formatDate } from "../utils.js";

const CreativeGridCard = ({ media, selected, onSelect, onClick, isVideo }) => {
  const handleCheckboxClick = (e) => {
    e.stopPropagation();
    onSelect(media.id);
  };

  const dimensions = media.width && media.height
    ? `${media.width}x${media.height}`
    : null;

  return (
    <div
      className={`creative-card${selected ? " creative-card--selected" : ""}`}
      onClick={() => onClick(media)}
    >
      <div className="creative-card__thumbnail">
        {media.key ? (
          <MediaFetcher
            mediaKey={media.key}
            width="100%"
            height="100%"
            objectFit="cover"
          />
        ) : (
          <div className="creative-card__placeholder">?</div>
        )}
      </div>

      <div className="creative-card__checkbox">
        <Checkbox
          checked={selected}
          onClick={handleCheckboxClick}
        />
      </div>

      {isVideo && (
        <div className="creative-card__video-badge">
          <PlayCircleFilled />
        </div>
      )}

      <div className="creative-card__info">
        <div className="creative-card__name" title={media.name}>
          {media.name || "Untitled"}
        </div>
        <div className="creative-card__meta">
          {[dimensions, media.mediaType].filter(Boolean).join(" \u00B7 ")}
        </div>
        {media.createdAt && (
          <div className="creative-card__date">
            {formatDate(media.createdAt)}
          </div>
        )}
      </div>
    </div>
  );
};

export default CreativeGridCard;
